import React from 'react';
import LeaderboardWidgetCellTitle from './leaderboard-widget-cell-title';

const LeaderboardWidgetRowTitle = ({ numberOfCells, titleText, topPlayersToShowState }) => {
    return (
        <div className="leaderboard-widget__row is-title">
            {
                numberOfCells.map((item) => {
                    return <LeaderboardWidgetCellTitle
                        key={item.id}
                        state={item}
                        topPlayersToShowState={topPlayersToShowState}
                        titleText={titleText} />;
                })
            }
        </div>
    );
};

export default LeaderboardWidgetRowTitle;
